// Keep ad-click references out of local storage and general product analytics.
export const readChatgptClickRef = (search = window.location.search) => {
  const value = new URLSearchParams(search).get('oppref');
  return value && value.length <= 2048 && !/[\s\u0000-\u001f\u007f]/.test(value) ? value : null;
};

export const signupAdsConsent = (allowed, search) => {
  const oppref = allowed ? readChatgptClickRef(search) : null;
  return oppref ? { consent: 'granted', oppref, consent_version: '2026-10-03' } : undefined;
};
